import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Book, Map, Brain, MessageSquare, User, FileText } from 'lucide-react';

function Footer() {
  const navigate = useNavigate();
  
  return (
    <footer className="bg-parchment-dark text-parchment-light py-12 font-serif">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <Book className="h-5 w-5" />
              Navigation
            </h3>
            <div className="flex flex-col space-y-2">
              <button onClick={() => navigate("/")} className="hover:text-parchment transition-colors">Home</button>
              <button onClick={() => navigate("/about")} className="hover:text-parchment transition-colors">About</button>
              <button onClick={() => navigate("/chat")} className="hover:text-parchment transition-colors">AI Tutor</button>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <Map className="h-5 w-5" />
              Features
            </h3>
            <div className="flex flex-col space-y-2">
              <button onClick={() => navigate("/timeline")} className="hover:text-parchment transition-colors">Timeline</button>
              <button onClick={() => navigate("/map")} className="hover:text-parchment transition-colors">World History</button>
              <button onClick={() => navigate("/quiz")} className="hover:text-parchment transition-colors">Quiz</button>
            </div>
          </div>
          
          {/* <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <User className="h-5 w-5" />
              Account
            </h3>
            <div className="flex flex-col space-y-2">
              <button onClick={() => navigate("/register")} className="hover:text-parchment transition-colors">Sign Up</button>
              <button onClick={() => navigate("/login")} className="hover:text-parchment transition-colors">Login</button>
            </div>
          </div> */}
          
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <FileText className="h-5 w-5" />
              Legal
            </h3>
            <div className="flex flex-col space-y-2">
              <button onClick={() => navigate("/policy")} className="hover:text-parchment transition-colors">Privacy Policy</button>
              <button onClick={() => navigate("/termsofpolicy")} className="hover:text-parchment transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-parchment/20">
          <p className="text-center text-parchment/60">
            © {new Date().getFullYear()} AI History Tutor. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;